import type { SVGProps } from "react";
export interface TruckDelayIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function TruckDelayIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: TruckDelayIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m15.05 17.875.116.006a1.125 1.125 0 0 1 0 2.238l-.116.006H10a1.126 1.126 0 0 1 0-2.25zM20.875 16v-2.875H16.5A2.125 2.125 0 0 1 14.375 11V6a.88.88 0 0 0-.605-.832l-.157-.036-.112-.02a1.126 1.126 0 0 1 .282-2.22l.116.008.284.05a3.12 3.12 0 0 1 2.436 2.925h.84c1.02 0 1.975.498 2.56 1.333l2.36 3.372.171.267q.198.339.328.706.008.018.015.038c.15.433.232.89.232 1.355V16a4.13 4.13 0 0 1-2.86 3.927l-.111.03a1.125 1.125 0 0 1-.579-2.171l.14-.052A1.88 1.88 0 0 0 20.874 16Zm-20 0v-3.04a1.125 1.125 0 0 1 2.25 0V16c0 .814.52 1.51 1.25 1.768a1.125 1.125 0 0 1-.75 2.123A4.13 4.13 0 0 1 .875 16m15.75-5.125h3.214l-1.664-2.376a.87.87 0 0 0-.716-.374h-.834z"
      />
      <path
        fill={color}
        d="M8.875 19a1.876 1.876 0 1 0-3.752 0 1.876 1.876 0 0 0 3.752 0m10 .5a1.376 1.376 0 1 0-2.752.001 1.376 1.376 0 0 0 2.752 0ZM8.875 6a2.875 2.875 0 1 0-5.75 0 2.875 2.875 0 0 0 5.75 0m-4-1.25a1.125 1.125 0 0 1 2.25 0v.372l.15.038.11.033a1.125 1.125 0 0 1-.542 2.171l-.114-.022-1.002-.25A1.13 1.13 0 0 1 4.875 6zm16.25 14.75a3.625 3.625 0 1 1-7.25-.001 3.625 3.625 0 0 1 7.25.002Zm-10-.5a4.125 4.125 0 1 1-8.25 0 4.125 4.125 0 0 1 8.25 0m0-13A5.124 5.124 0 1 1 .875 6a5.124 5.124 0 0 1 10.248 0Z"
      />
    </svg>
  );
}
